import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Organization, PaginationModel } from "../model/organization";
import { addChildOrganizationsToOrganization, fetchChildOrganizations } from "./asyncThunks";

export const OrganizationTitle = { Add: "Create Organization", Edit: "Edit Organization" };

export const initialChildOrganizationState = {
    childOrganizations: [] as Organization[],
    childOrganizationListPagination: {
        startRow: 0,
        rowsPerPage: 25,
        rowsPerPageOptions: [25, 50, 100],
        totalRowCount: 0,
    } as PaginationModel,
};

export const childOrganizationListSlice = createSlice({
    name: "childOrganizationList",
    initialState: initialChildOrganizationState,
    reducers: {
        onChangeChildOrganizationPage: (state, action): void => {
            state.childOrganizationListPagination.startRow = action.payload;
        },
        onChangeChildOrganizationRowPerPage: (state, action): void => {
            state.childOrganizationListPagination.rowsPerPage = action.payload;
        },
        onChangeTotalCount: (state, action): void => {
            state.childOrganizationListPagination.totalRowCount = action.payload;
        },
    },
    extraReducers: {
        [`${fetchChildOrganizations.fulfilled}`]: (state, action): void => {
            state.childOrganizations = action.payload;
            state.childOrganizationListPagination.startRow = 0;
            state.childOrganizationListPagination.totalRowCount = state.childOrganizations.length;
        },
        [`${addChildOrganizationsToOrganization.fulfilled}`]: (state, action): void => {
            state.childOrganizations = action.payload;
            state.childOrganizationListPagination.startRow = 0;
            state.childOrganizationListPagination.totalRowCount = state.childOrganizations.length;
        },
    },
});

// Actions
export const {
    onChangeChildOrganizationPage,
    onChangeChildOrganizationRowPerPage,
    onChangeTotalCount
} = childOrganizationListSlice.actions;

// Selectors
export const childOrganizationsSelector = (state: RootState) => state.childOrganizationList.childOrganizations;

export const childOrganizationListPaginationSelector = (state: RootState): PaginationModel =>
    state.childOrganizationList.childOrganizationListPagination;